<template>
  <div class="about-page">
    <div class="about-inner">
      <!-- 左侧栏目导航 -->
      <aside class="about-nav">
        <h3 class="about-nav__title">关于国数网</h3>
        <ul>
          <li
            v-for="(item, index) in menuItems"
            :key="index"
            :class="{ active: activeIndex === index }"
          >
            <a :href="`#${item.title}`" class="about-nav__link" @click="onNavClick($event, item.title)">{{ item.title }}</a>
          </li>
        </ul>
      </aside>

      <!-- 右侧内容 -->
      <main class="about-content">
        <section
          v-for="(item, index) in menuItems"
          :key="index"
          :id="item.title"
          class="about-section"
        >
          <h2 class="about-section__title">{{ item.title }}</h2>
          <div class="about-section__body" v-html="item.content"></div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return { offsetPx: 129,

      activeIndex: 0,
      menuItems: [
        {
          title: '关于我们',
          content: `
            <p>国数网（Data assets）是面向数据要素市场的综合服务平台，围绕“数据资源—数据集—数据产品—数据交易”的链路，为企业、机构与从业者提供数据资产登记展示、供需对接、交易撮合与专业服务。</p>
            <p>平台目前设有企业资料、数据资源、数据集、数据交易大厅、数据服务商、数据地图、数据资产商学院、国数探索实验室等板块，覆盖数据资源登记、数据集挂牌、需求与供给入驻、数据服务商展示、专家智库与行业资讯等内容。</p>
            <p>我们坚持“以企业为轴”的组织方式：以企业（组织机构）为主体串联数据资源、数据集、交易记录与专业服务，帮助数据持有方、数据需求方和服务机构在同一套名录体系下被发现、被理解、被连接。</p>
            <p>国数网持续跟踪国家数据要素政策与地方实践，通过资讯、专访、案例与研究报告，为数据资产的确权、登记、评估、入表与流通提供可参考的路径。</p>
            <p>
              联系我们<br>
              服务电话：马老师 15010090628<br>
              商务合作：马老师 15010090628<br>
              市场邮箱：marketing@shujuzichan.com<br>
              办公地址：北京市丰台区星火路1号院昌宁大厦2号楼602
            </p>
          `
        },
        {
          title: '隐私政策',
          content: `
            <p>
              更新日期：2026年10月27日<br>
              生效日期：2026年10月27日<br>
              一、适用范围<br>
              本政策适用于国数网（以下简称“本平台”）提供的网站、页面与相关服务。您在使用本平台服务时，我们可能依据本政策收集、使用、存储和保护您的信息。<br>
              二、我们收集的信息<br>
              1. 您主动提交的信息：包括企业信息申请、专家库申请、数据需求申请、数据服务登记等表单中填写的名称、联系人、联系方式、职务、地区、机构介绍、资质材料等。<br>
              2. 您在使用服务过程中产生的信息：包括访问日志、页面操作记录、设备与浏览器信息等。<br>
              三、我们如何使用信息<br>
              1. 用于身份与资质核验、内容审核与展示；<br>
              2. 用于供需匹配、业务联络与服务改进；<br>
              3. 用于安全防护、异常排查与合规审计。<br>
              四、信息的共享与披露<br>
              除法律法规要求或经您授权外，我们不会向第三方提供您的个人信息。因业务需要向合作方提供时，我们会以必要范围为限，并要求其承担保密义务。<br>
              五、信息的存储与保护<br>
              我们采取访问控制、传输加密、日志审计等措施保护信息安全，并在实现处理目的所必需的期限内保存您的信息。<br>
              六、您的权利<br>
              您可以通过本页面公布的联系方式，查询、更正或删除您提交的信息，也可以要求撤回授权。<br>
              七、政策更新<br>
              本政策更新后将在本页面公布，重大变更将以显著方式提示。
            </p>
          `
        },
        {
          title: '版权政策',
          content: `
            <p>
              一、平台内容权属<br>
              本平台发布的文字、图片、图表、页面设计、数据汇编及栏目编排，其著作权归国数网或相应权利人所有。未经书面许可，任何单位或个人不得以复制、转载、镜像、抓取等方式使用。<br>
              二、用户提交内容<br>
              您在本平台提交的企业资料、数据集介绍、专访素材等内容，应保证拥有合法权利或已获得权利人授权。您授予本平台在展示、推广、汇编等必要范围内使用该内容的非独占许可。<br>
              三、转载与引用<br>
              需转载本平台原创内容的，应注明“来源：国数网”并保持内容完整，不得断章取义或用于误导性宣传；用于商业用途的，须事先取得书面授权。<br>
              四、侵权处理<br>
              如您认为本平台内容侵犯您的合法权益，请提供权属证明与具体链接，我们将在核实后及时处理。<br>
              五、联系方式<br>
              版权事宜请通过本页面公布的联系方式与我们联系。
            </p>
          `
        },
        {
          title: '会员服务协议',
          content: `
            <p>
              一、协议主体<br>
              本协议由国数网（以下简称“本平台”）与注册或使用本平台服务的用户（以下简称“用户”）共同遵守。<br>
              二、账号与身份<br>
              用户应提供真实、准确的企业或个人资料，并对账号下的操作负责。以企业名义注册的，应确保有权代表该企业。<br>
              三、服务内容<br>
              本平台提供数据资源与数据集展示、供需信息发布、交易撮合信息、数据服务商展示、行业资讯与专家内容等服务，具体以页面实际提供为准。<br>
              四、用户行为规范<br>
              用户不得发布虚假、侵权、违法或危害数据安全的信息；不得利用本平台从事窃取数据、非法交易数据等行为。<br>
              五、内容审核<br>
              本平台对用户提交的信息进行审核，有权对不符合规范的内容不予展示或予以删除。<br>
              六、服务变更与终止<br>
              本平台可根据业务需要调整服务内容；用户违反本协议或法律法规的，本平台有权限制或终止其使用。<br>
              七、免责声明<br>
              本平台展示的供需与交易信息由用户提供，交易双方应自行完成尽职调查并承担相应风险。
            </p>
          `
        },
        {
          title: '加入我们',
          content: `
            <p>
              国数网聚焦数据要素流通与数据资产服务，团队由产品、数据、行业研究与运营人员组成。我们长期招聘以下方向的人才：<br>
              1. 数据产品经理：负责数据资源登记、数据集管理与交易撮合类产品设计；<br>
              2. 数据治理工程师：负责数据标准、质量管理与数据资产盘点；<br>
              3. 行业研究员：跟踪数据要素政策与地方实践，产出研究报告与案例；<br>
              4. 平台运营：负责企业入驻、供需对接与内容运营。
            </p>
            <p>
              任职要求：<br>
              1. 本科及以上学历，数据科学、统计学、计算机、经济学等相关专业优先；<br>
              2. 具备数据要素、数据治理、产业研究或平台运营相关经验者优先；<br>
              3. 具备良好的沟通协作能力与文字表达能力。
            </p>
            <p>
              工作地点：北京<br>
              简历投递：marketing@shujuzichan.com（邮件标题注明“应聘-岗位-姓名”）<br>
              联系电话：15010090628
            </p>
          `
        },
      ],
      sectionOffsets: [],
        scrollPosition: 0
    }
  },
  mounted() {
    this.syncHeaderVar()
    this.applyHash()
    window.addEventListener('scroll', this.handleScroll)
      this.calculateSectionOffsets()
    window.addEventListener('resize', this.calculateSectionOffsets)
      // 添加路由参数检查
    this.$nextTick(() => {
      if (this.$route.params.name) {
          setTimeout(() => {
            this.scrollToMembership()
          }, 300) // 延迟确保DOM完全渲染
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.calculateSectionOffsets)
  },
  computed: {
    /** 左侧大纲吸附位置（避开固定导航） */
    stickyTop() {
      const el = typeof document !== 'undefined' ? (document.querySelector('header') || document.querySelector('.header')) : null
      const h = el ? Math.round(el.getBoundingClientRect().height) : 96
      return h + 16
    },
  },
  methods: {
    /** 兜底：某些情况下浏览器默认的 hash 跳转会被吞，这里显式处理一次 */
    onNavClick(event, title) {
      const el = document.getElementById(title)
      if (!el) return
      event.preventDefault()
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', `${location.pathname}#${title}`)
      }
      const idx = this.menuItems.findIndex((i) => i.title === title)
      if (idx >= 0) this.activeIndex = idx
    },
    /** 首次进入带 #锚点 时，等 DOM 渲染完再滚一次（SPA 首屏浏览器不会自动滚） */
    applyHash() {
      const hash = typeof window !== 'undefined' ? window.location.hash : ''
      if (!hash) return
      const id = decodeURIComponent(hash.slice(1))
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.getElementById(id)
          if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' })
          this.activeIndex = this.menuItems.findIndex((i) => i.title === id)
        }, 120)
      })
    },
    /** 把固定导航高度写进 CSS 变量，锚点与吸顶都用它 */
    syncHeaderVar() {
      const el = document.querySelector('header') || document.querySelector('.header')
      const crumb = document.querySelector('.el-breadcrumb') || document.querySelector('[class*=bread]')
      const h = (el ? el.getBoundingClientRect().height : 96) + (crumb ? crumb.getBoundingClientRect().height : 0)
      this.offsetPx = Math.round(h) + 12
      document.documentElement.style.setProperty('--header-h', this.offsetPx + 'px')
      this.calculateSectionOffsets()
    },
    /** 点左侧大纲：滚到标题，地址同步成 #标题 */
    goSection(index) {
      const item = this.menuItems[index]
      if (!item) return
      const el = document.getElementById(item.title)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      this.activeIndex = index
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', `${location.pathname}#${item.title}`)
      }
    },
    /** 原生锚点跳转，这里只负责高亮状态 */
    onAnchorClick(index) {
      this.activeIndex = index
    },
    /** 固定导航的真实高度（header 是 fixed，锚点和吸顶都要避开它） */
    headerHeight() {
      const el = document.querySelector('header') || document.querySelector('.header')
      return el ? Math.round(el.getBoundingClientRect().height) : 96
    },
    /** 锚点跳转的偏移：导航高度 + 一点呼吸间距 */
    anchorOffset() {
      return this.headerHeight + 16
    },
    /** 当前每个章节的绝对位置，滚动时用来判断高亮 */
    calculateSectionOffsets() {
      this.$nextTick(() => {
        this.sectionOffsets = this.menuItems.map((_, index) => {
          const el = document.getElementById(this.menuItems[index] && this.menuItems[index].title)
          if (!el) return 0
          return el.getBoundingClientRect().top + window.scrollY
        })
      })
    },
    scrollToSection(index) {
      const el = document.getElementById(`section-${index}`)
      if (!el) return
      const top = el.getBoundingClientRect().top + window.scrollY - this.anchorOffset()
      this.activeIndex = index
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
    },
    handleScroll() {
      // 标题顶部越过「导航+面包屑」这条线，就算当前章节
      const line = this.offsetPx + 24
      let current = 0
      this.menuItems.forEach((item, index) => {
        const el = document.getElementById(item.title)
        if (el && el.getBoundingClientRect().top <= line) current = index
      })
      this.activeIndex = current
    },
    /** 从页脚点进来时（/about/隐私政策）直接定位到对应章节 */
    /** 兼容老地址 /about/xxx：直接改写成 #xxx，滚动交给浏览器 */
    scrollToMembership() {
      const name = this.$route.params.name
      if (!name) return
      if (typeof window !== 'undefined' && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', `${window.location.pathname}#${name}`)
        const el = document.getElementById(name)
        if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' })
      }
    }
  }
}
</script>

<style scoped>
.about-page {
  background: #fff;
  padding: 20px 0 60px;
}
.about-inner {
  width: 1200px;
  max-width: 92%;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

/* 左侧导航 */
.about-content section[id] {
  /* 原生锚点落点：避开固定导航（--header-h 由 mounted 动态写入） */
  scroll-margin-top: 170px;
}

.about-nav {
  flex: 0 0 220px;
  width: 220px;
  position: sticky;
  top: 170px;
  background: #fff;
  border: 1px solid #E8EEF7;
  border-radius: 12px;
  padding: 16px 12px;
}
.about-nav__title {
  margin: 0 0 10px;
  padding: 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: #111824;
}
.about-nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.about-nav li a {
  display: block;
  padding: 11px 12px;
  border-radius: 8px;
  color: inherit;
  text-decoration: none;
}

.about-nav li {
  padding: 0;
  margin-bottom: 4px;
  border-radius: 8px;
  font-size: 14px;
  color: #4A5568;
  cursor: pointer;
  transition: background .2s, color .2s;
}
.about-nav li:hover {
  background: #F0F5FF;
  color: #0165FF;
}
.about-nav li.active {
  background: #E8F1FF;
  color: #0165FF;
  font-weight: 600;
}

/* 右侧内容 */
.about-content {
  flex: 1 1 auto;
  min-width: 0;
  background: #fff;
  border: 1px solid #E8EEF7;
  border-radius: 12px;
  padding: 28px 36px 8px;
}
.about-section {
  padding-bottom: 26px;
  margin-bottom: 26px;
  border-bottom: 1px solid #EEF2F8;
}
.about-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.about-section__title {
  margin: 0 0 16px;
  padding-left: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #111824;
  border-left: 4px solid #0165FF;
  line-height: 1.3;
}
.about-section__body {
  font-size: 14px;
  line-height: 1.9;
  color: #3D4757;
}
.about-section__body :deep(p) {
  margin: 0 0 12px;
  line-height: 1.9;
}
.about-section__body :deep(br) {
  line-height: 2.1;
}

@media (max-width: 1024px) {
  .about-inner {
    flex-direction: column;
  }
  .about-nav {
    position: static;
    width: 100%;
    flex: none;
  }
  .about-content {
    padding: 20px 18px 4px;
  }
}
</style>

<style>
/* v-html 渲染出来的富文本统一排版 */
.about-section__body p {
  margin: 0 0 12px;
  line-height: 1.9;
  font-size: 14px;
  color: #3D4757;
}
.about-section__body br {
  line-height: 2.1;
}
</style>